export default function BlogHero() {
  return (
    <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/16d7061da22724859128c72d4332b795.jpg"
          alt="Painting and Decorating Blog"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Painting &amp; Decorating Insights
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-white/95">
          Expert tips, DIY advice, and industry insights from Watford's trusted painting professionals
        </p>
        <div className="flex flex-wrap justify-center gap-4 text-sm">
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
            <i className="ri-lightbulb-line text-lg"></i>
            <span>Professional Tips</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
            <i className="ri-tools-line text-lg"></i>
            <span>DIY Guides</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
            <i className="ri-home-smile-line text-lg"></i>
            <span>Home Improvement</span>
          </div>
        </div>
      </div>
    </section>
  );
}